export default "__VITE_ASSET__Dj7$KE9J__"